import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import Login from './pages/Login';
import AdminDashboard from './pages/AdminDashboard';
import Home from './pages/Home';
import AllProperties from './pages/AllProperties';
import AllServices from './pages/AllServices';
import Banners from './pages/Banners';
import GuestSubmission from './pages/GuestSubmission';
import { LanguageProvider } from './context/LanguageContext';
import { apiService } from './services/api';

function AppContent() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    verifyAuth();
  }, []);

  const verifyAuth = async () => {
    try {
      const token = apiService.getAuthToken();
      if (token) {
        const response = await apiService.verifyToken();
        setIsAuthenticated(response.success);
        console.log('✅ Auth check result:', response.success);
      } else {
        setIsAuthenticated(false);
      }
    } catch (error) {
      console.error('❌ Auth verification failed:', error);
      setIsAuthenticated(false);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Box sx={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        minHeight: '100vh',
        bgcolor: '#f5f5f5'
      }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Switch>
      {/* Public Routes */}
      <Route exact path="/" component={Home} />
      <Route path="/all-properties" component={AllProperties} />
      <Route path="/all-services" component={AllServices} />
      <Route path="/banners" component={Banners} />
      <Route path="/submit" component={GuestSubmission} />
      <Route path="/login" component={Login} />

      {/* Protected Admin Route */}
      <Route path="/admin-dashboard">
        {isAuthenticated ? <AdminDashboard /> : <Redirect to="/login" />}
      </Route>

      {/* 404 Fallback - Must be last */}
      <Route render={() => <Redirect to="/" />} />
    </Switch>
  );
}

function App() {
  return (
    <LanguageProvider>
      <Router>
        <AppContent />
      </Router>
    </LanguageProvider>
  );
}

export default App;